import React from 'react';

const TextDisplay = ({ title, show = true, children }) =>
  show ? (
    <dl
      style={{
        fontSize: '16px',
        width: '100%',
        display: 'flex',
        flexFlow: 'row',
        flexWrap: 'wrap',
        overflow: 'visible',
        padding: '2px 0',
        margin: 0,
      }}
    >
      <dt
        style={{
          fontWeight: 'bold',
          flex: '0 0 30%',
          margin: 0,
          padding: '4px 8px 2px 8px',
        }}
      >
        {title}
      </dt>
      <dd
        style={{
          flex: '0 0 70%',
          marginLeft: 'auto',
          textAlign: 'left',
          margin: 0,
          padding: '4px 8px 2px 8px',
        }}
      >
        {children}
      </dd>
    </dl>
  ) : null;

export default TextDisplay;
